import React, { useState, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DrawerFiltersWrapper from '../../components/DrawerFiltersWrapper';
import SemanticInput from '../../components/SemanticInput';
import { options as RolesOptions, support } from '../../constants/Roles';
import SemanticDropdown from '../../components/SemanticDropdown';
import ButtonsFilter from '../../components/ButtonsFilter';
import feathers, { useAuth } from '../../services/feathers';

const queryInit = {
  Folio: null,
};

const reducerQuery = (prevState, { name, value, type, query }) => {
  if (type === 'init' && query) {
    return query;
  } else if (name) {
    return { ...prevState, [name]: value };
  }

  return prevState;
};

const Filters = ({ isBusy, setQuery, isValid }) => {
  const auth = useAuth();

  // States
  const [query, dispatchQuery] = useReducer(reducerQuery, { ...queryInit });
  const [roleOpts, setRoleOpts] = useState([]);
  const [clientOpts, setClientOpts] = useState([]);

  // Effects
  useEffect(() => {
    const sendQuery = () => {
      isValid && handleSearchClick();
    };

    sendQuery();
  }, [isValid]);

  useEffect(() => {
    const roleOpts = [...RolesOptions];
    if (!auth.user.isSupport) {
      const index = roleOpts.findIndex(({ value }) => value === support);
      roleOpts.splice(index, 1);
    }

    setRoleOpts(roleOpts);
  }, [auth.user]);

  useEffect(() => {
    let didCancel = false;

    const getClients = async () => {
      let options = [];

      if (auth && auth.user && auth.user.isSupport) {
        let result = await feathers.service('clients').find({
          query: {},
        });

        if (!didCancel) {
          options = result.data.map(({ _id, name }) => ({
            key: _id,
            text: name,
            value: _id,
          }));
        }
      }

      setClientOpts(options);
    };

    getClients();

    return () => {
      didCancel = true;
    };
  }, [auth]);

  // Handles
  const handleChangeInput = (_, { name, value }) =>
    dispatchQuery({ name, value });

  const handleSearchClick = () => {
    // Create query for feathers
    let queryMap = {
      ...(query.Folio && { Folio: query.Folio }),
      Organizacion: null,
    };

    if (auth.user) {
      queryMap.Organizacion = auth.user.client._id;
    }

    if (!auth.user.isSupport) {
      queryMap = {
        $and: [{ ...queryMap }],
      };
    }

    // console.debug('query', JSON.stringify(queryMap, null, 2));

    // Send query to Users
    setQuery && setQuery(queryMap);
  };

  const handleClearClick = (event, data) => {
    dispatchQuery({
      type: 'init',
      query: {
        ...queryInit,
      },
    });
  };

  return (
    <>
      {/* <pre>query: {JSON.stringify(query, null, 2)}</pre> */}
      <DrawerFiltersWrapper>
        <FiltersGrid>
          <SemanticInput
            name="Folio"
            label="Folio"
            placeholder="Buscar..."
            value={query.Folio}
            onChange={handleChangeInput}
            fluid
            style={{ gridArea: 'search' }}
            disabled={isBusy || !isValid}
          />
          <ButtonsFilter
            isBusy={isBusy || !isValid}
            onSearchClick={handleSearchClick}
            onClearClick={handleClearClick}
          />
        </FiltersGrid>
      </DrawerFiltersWrapper>
    </>
  );
};

const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;
  grid-gap: 1em;
  grid-template-areas: 'search role . buttons';
`;

Filters.propTypes = {
  isBusy: PropTypes.bool,
  setQuery: PropTypes.func,
  defaultUser: PropTypes.object,
  isValid: PropTypes.bool,
};

export default Filters;
